import React, { useRef, useEffect, useState } from "react";

const Confetti: React.FC<{ show: boolean }> = ({ show }) => {
  if (!show) return null;
  return null;
};

const RegisterRouter: React.FC<{ onRegistrationSuccess?: () => void }> = ({ onRegistrationSuccess }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [showConfetti, setShowConfetti] = useState(false);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const iframe = iframeRef.current;
      if (iframe) {
        try {
          const url = iframe.contentWindow?.location.href;
          if (url && (url.includes("/success") || url.includes("/dashboard"))) {
            window.postMessage("registration-success", "*");
            if (onRegistrationSuccess) onRegistrationSuccess();
            setShowConfetti(true);
            clearInterval(interval);
            setTimeout(() => setShowConfetti(false), 3500);
          }
        } catch (e) {
          // Cross-origin, ignore
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [onRegistrationSuccess]);

  return (
    <div className="w-full h-[80vh] md:h-[90vh] flex items-center justify-center bg-[#0c0c15] relative" style={{ marginTop: 15 }}>
      <Confetti show={showConfetti} />
      <iframe
        ref={iframeRef}
        src="https://getlicense.solanavolumebot.io/register?trial=1"
        title="Solana Volume Bot Registration"
        className="w-full h-full rounded-2xl border-none shadow-2xl"
        allow="clipboard-write"
        style={{ minHeight: 500 }}
      />
    </div>
  );
};

export default RegisterRouter; 